import React from "react";
import { useFormContext, useController } from "react-hook-form";

interface PaziaCheckboxProps {
  name: string;
  label?: string | React.ReactNode;
  onChange?: (checked: boolean) => void;
  disabled?: boolean;
}
export const PaziaCheckbox = ({
  name,
  onChange,
  label,
  disabled,
}: PaziaCheckboxProps): JSX.Element => {
  const { control } = useFormContext();

  const { field } = useController({
    name,
    control,
  });

  const onChangeHandler = (isChecked: boolean) => {
    field.onChange(isChecked);
    if (onChange) onChange(isChecked);
  };

  const disabledClass = disabled ? "opacity-50 cursor-not-allowed" : "";

  const inputComponent = (
    <input
      type="checkbox"
      className={`form-checkbox ${disabledClass}`}
      value={field.value}
      checked={field.value}
      disabled={disabled}
      onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
        onChangeHandler(e.target.checked)
      }
    />
  );

  if (label) {
    return (
      <div
        className="cursor-pointer"
        onClick={() => onChangeHandler(!field.value)}
      >
        {inputComponent}
        <span className="ml-2">{label}</span>
      </div>
    );
  }

  return inputComponent;
};
